import { DocumentDto } from '@ecdlink/core';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import localForage from 'localforage';
import {
  createDocument,
  getDocumentsForHCW,
  upsertDocument,
} from './document.actions';
import { DocumentState } from './document.types';
import { setFulfilledThunkActionStatus, setThunkActionStatus } from '../utils';

const initialState: DocumentState = {
  documentsForHCW: [],
};

const documentSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    resetDocumentsState: (state) => {
      state.documentsForHCW = initialState.documentsForHCW;
    },
    clearSyncStatus: (state) => {
      if (state.documentsForHCW) {
        for (let i = 0; i < state.documentsForHCW.length; i++) {
          if (
            'synced' in state.documentsForHCW[i] &&
            state.documentsForHCW[i].synced === false
          ) {
            state.documentsForHCW[i] = {
              ...state.documentsForHCW[i],
              synced: true,
            };
          }
        }
      }
    },
    createDocument: (state, action: PayloadAction<DocumentDto>) => {
      if (!state.documentsForHCW) state.documentsForHCW = [];
      state.documentsForHCW?.push(action.payload);
    },
    deleteDocument: (state, action: PayloadAction<DocumentDto>) => {
      if (!state.documentsForHCW) return;

      const index = state.documentsForHCW.findIndex(
        (c) => c.id === action.payload.id
      );

      if (index > -1) state.documentsForHCW?.splice(index, 1);
    },
    updateDocument: (state, action: PayloadAction<DocumentDto>) => {
      if (!state.documentsForHCW) return;

      const index = state.documentsForHCW.findIndex(
        (c) => c.id === action.payload.id
      );

      if (index < 0) return;

      state.documentsForHCW[index] = action.payload;
    },
  },
  extraReducers: (builder) => {
    setThunkActionStatus(builder, createDocument);
    setThunkActionStatus(builder, upsertDocument);
    builder.addCase(getDocumentsForHCW.fulfilled, (state, action) => {
      // Create deep copies to avoid reference issues
      const newDocs = action.payload
        .filter((doc) => !state.documentsForHCW.some((d) => d.id === doc.id))
        .map((doc) => ({ ...doc })); // Shallow clone each document

      state.documentsForHCW.push(...newDocs);
    });
    builder.addCase(createDocument.fulfilled, (state, action) => {
      setFulfilledThunkActionStatus(state, action);
    });
    builder.addCase(upsertDocument.fulfilled, (state, action) => {
      if (!action.payload || !state.documentsForHCW) return;

      state.documentsForHCW = state.documentsForHCW?.map((item) => {
        return { ...item, synced: true };
      });
      setFulfilledThunkActionStatus(state, action);
    });
  },
});

const { reducer: documentReducer, actions: documentActions } = documentSlice;

const documentPersistConfig = {
  key: 'documents',
  storage: localForage,
  blacklist: [],
};

export { documentPersistConfig, documentReducer, documentActions };
